interface Options {
  checkIn?: string
  charterBundleRoute?: App.CharterBundleRoute
  flightOriginCode?: string
  offer: App.HotelOffer
  totalFlightPrice?: number | null
}

export default function getEffectiveHotelFlightPrice(options: Options): number {
  const {
    checkIn,
    charterBundleRoute,
    flightOriginCode,
    offer,
    totalFlightPrice,
  } = options

  if (totalFlightPrice != null && totalFlightPrice > 0) {
    return totalFlightPrice
  }

  const cachedFlightPrice = flightOriginCode ? (offer.flightPrices?.[flightOriginCode] ?? 0) : 0
  const shouldUseCachedFlightPrice = !charterBundleRoute && !checkIn && !offer.flightCacheDisabled && cachedFlightPrice > 0

  return shouldUseCachedFlightPrice ? cachedFlightPrice : 0
}
